export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10062.c9f78379.jpg";